<template src="./index.html"></template>

<script>
import { getYear, getFinancialPeriod, getDetailType, reportSubmit, inquiryAliasConfig, getCACodeDesc, getTCodeByNumber, getCurrencyConfigData } from '../../../../api/home.js';
import { getdata } from './data.js';
export default {
	name: 'DetailedStatement',
	data() {
		return {
			fxdmData: [],
			baoblx: ['0'],
			//基本信息
			formlistjbxx: getdata().formlistjbxx,
			formdatajbxx: getdata().formdatajbxx,
			//中方科目
			formlistzfkm: getdata().formlistzfkm,
			formdatazfkm: getdata().formdatazfkm,
			//验证
			ispassjbxx: false,
			ispasszfkm: false,
			fxdm: [],
			rangs: []
		};
	},
	watch: {
		'formdatajbxx.cains': function(indexVal, oldVal) {
			this.formdatajbxx.qij1 = '';
			this.formdatajbxx.qij2 = '';
			this.GainCwqj(indexVal);
		}
	},
	mounted() {},
	created() {
		this.searrchForData();
	},
	methods: {
		selectTrigger(index) {
			let params = {};
			params.number = this.fxdmData[index].tcode;
			getTCodeByNumber(params).then(res => {
				if (res.data.code == '200') {
					this.rangs[index] = res.data.data.map(v => {
						return {
							label: v.refCode,
							value: v.refCode
						};
					});
					this.$forceUpdate();
				}
			});
		},
		//获取分析代码
		GainFXDM() {
			inquiryAliasConfig().then(res1 => {
				if (res1.data.code == '200') {
					this.fxdm = [];
					for (var i in res1.data.data) {
						if (i.substring(0, 5) == 'tcode' && this.$notemptyandnull(res1.data.data[i]) && i.length < 10) {
							this.fxdm.push({ label: res1.data.data[i], value: i.slice(5) });
						}
					}
					// if (res1.data.data.tcode1 != '' && res1.data.data.tcode1 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode1, value: '1' });
					// }
					// if (res1.data.data.tcode2 != '' && res1.data.data.tcode2 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode2, value: '2' });
					// }
					// if (res1.data.data.tcode3 != '' && res1.data.data.tcode3 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode3, value: '3' });
					// }
					// if (res1.data.data.tcode4 != '' && res1.data.data.tcode4 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode4, value: '4' });
					// }
					// if (res1.data.data.tcode5 != '' && res1.data.data.tcode5 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode5, value: '5' });
					// }
					// if (res1.data.data.tcode6 != '' && res1.data.data.tcode6 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode6, value: '6' });
					// }
					// if (res1.data.data.tcode7 != '' && res1.data.data.tcode7 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode7, value: '7' });
					// }
					// if (res1.data.data.tcode8 != '' && res1.data.data.tcode8 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode8, value: '8' });
					// }
					// if (res1.data.data.tcode9 != '' && res1.data.data.tcode9 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode9, value: '9' });
					// }
					// if (res1.data.data.tcode10 != '' && res1.data.data.tcode10 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode10, value: '10' });
					// }
					this.searchlist = getdata().searchlist;
					this.searchlist[0].selectval = this.fxdm;
				}
			});
		},

		//重置
		empty() {
			this.fxdmData = [];
			this.baoblx = [];
			this.formdatajbxx = getdata().formdatajbxx;
			this.formdatazfkm = getdata().formdatazfkm;
			this.$nextTick(() => {
				this.$refs.taxformjbxx.clearValidate();
				this.$refs.taxformzfkm.clearValidate();
			});
		},
		//通过验证最后的保存
		SaveExecution() {
			if (this.ispassjbxx && this.ispasszfkm) {
				let params = {};
				params.json = JSON.stringify({ name: '明细账报表后台任务', taskDesc: 'test', subType: '7' });
				let param = {};
				param.cains = [];
				param.cains.push(this.formdatajbxx.cains.toString());
				param.qij = [];
				param.qij.push(this.formdatajbxx.qij1.toString());
				param.qij.push(this.formdatajbxx.qij2.toString());
				param.currency = this.formdatajbxx.currency;
				param.baoblx = this.baoblx;
				param.zhongfkmStart = this.formdatazfkm.zhongfkmStart;
				param.zhongfkmEnd = this.formdatazfkm.zhongfkmEnd;
				param.tCodes = this.fxdmData;
				params.param = JSON.stringify(param);
				reportSubmit(params).then(res => {
					if (res.data.code == '200') {
						this.$message.success('生成成功');
						this.$router.push({
							path: '/ReportTask',
						});
					} else {
						this.$message.error(res.data.message);
					}
				});
			}
		},
		//基本信息通过验证
		getdatajbxx() {
			this.ispassjbxx = true;
			this.SaveExecution();
		},
		//中方科目通过验证
		getdatazfkm() {
			this.ispasszfkm = true;
			if (this.projectType == "Amat" && (this.formdatajbxx.qij1 >= 14 || this.formdatajbxx.qij2 >= 14) && this.formdatajbxx.qij1 != this.formdatajbxx.qij2){
				this.$message.error("14、15期明细账只能导出当期");
				return;
			}
			this.SaveExecution();
		},
		//生成按钮验证
		generate() {
			this.ispassjbxx = false;
			this.ispasszfkm = false;
			this.$refs.taxformjbxx.submitForm();
			this.$refs.taxformzfkm.submitForm();
		},
		//初始化查询
		searrchForData() {
			this.formlistjbxx = getdata().formlistjbxx;
			this.GainNd();
			this.GainKmdm();
			this.GainFXDM();
			this.GainBz();
		},
		//获取年度
		GainNd() {
			let params = {};
			getYear().then(res => {
				this.formdatajbxx.cains = new Date().getFullYear();
				for (var i = res.data.data.max; i >= res.data.data.min; i--) {
					this.formlistjbxx[0].selectval.push({
						label: i,
						value: i
					});
				}
			});
		},
		//获取科目代码
		GainKmdm() {
			let params = {};
			params.likeSearch = '';
			params.isLastLevel = false;
			getCACodeDesc(params).then(res => {
				if (res.data.code == '200') {
					this.formlistzfkm[0].selectval = res.data.data.map(v => {
						return {
							label: v.key+"-"+v.value,
							value: v.key
						};
					});
					this.formlistzfkm[1].selectval = res.data.data.map(v => {
						return {
							label: v.key+"-"+v.value,
							value: v.key
						};
					});
				}
			});
		},
		//获取财务期间
		GainCwqj(year) {
			let params = {};
			params.year = year;
			getFinancialPeriod(params).then(res => {
				if (res.data.code == '200') {
					this.formlistjbxx[1].selectval = res.data.data.map(v => {
						return {
							label: v.name,
							value: v.value
						};
					});
					this.formlistjbxx[3].selectval = res.data.data.map(v => {
						return {
							label: v.name,
							value: v.value
						};
					});
				} else {
					this.formdatajbxx.qij1 = '';
					this.formdatajbxx.qij2 = '';
					this.formlistjbxx[1].selectval = [];
					this.formlistjbxx[3].selectval = [];
				}
				let currencyMonth = new Date().getMonth() + 1;
				this.formdatajbxx.qij1 = currencyMonth;
				this.formdatajbxx.qij2 = currencyMonth;
			});
		},
		//获取币种 TODO 默认选中本币
		GainBz() {
			let params = {};
			getCurrencyConfigData().then(res => {
				if (res.data.code == '200') {
					this.formlistjbxx[2].selectval = res.data.data.map(v => {
						if (v.standardCurrency == '1') {
							this.formdatajbxx.currency = v.currency;
						}
						return {
							label: v.currency,
							value: v.currency
						};
					});
				}
			});
		},
		adddm(k) {
			let inte = k == 0 ? 0 : k + 1;
			this.fxdmData.splice(inte, 0, {});
		},
		deletedm(k) {
			this.fxdmData.splice(k, 1);
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
